// extracted by mini-css-extract-plugin
export default {"group":"formGroup_group__+BEiX","vertical":"formGroup_vertical__yMrwV","fullWidth":"formGroup_fullWidth__RfF5t"};